import React, { useState } from "react";
import { Group, Stack, Divider, Button, Text, Input } from "@mantine/core";
import { ReactComponent as ExclamationIcon } from "./exclamation-icon.svg";

interface UpdateTypeConfirmationProps {
    onConfirm: (otherDocumentTypeText?: string) => void;
    onCancel: () => void;
    type: string;
}

const UpdateTypeConfirmation: React.FC<UpdateTypeConfirmationProps> = ({
    type,
    onConfirm,
    onCancel,
}) => {
    const [otherDocumentTypeText, setOtherDocumentTypeText] = useState('')

    return (
        <div className="delete-confirmation-overlay">
            <div className="delete-confirmation-box">
                <Group spacing="sm" className="delete-confirmation-header">
                    <div className="delete-confirmation-icon-box">
                        <ExclamationIcon />
                    </div>
                    <Stack pb="10px">
                        <Text className="delete-confirmation-title">Confirm</Text>
                        <Text className="delete-confirmation-message">
                            Are you sure you want to change the document type?
                        </Text>
                    </Stack>
                </Group>
                {type === 'Other' && (
                    <Group spacing="md" w="100%" align="center" noWrap py="md">
                        <Text size="xl" weight={500} style={{ whiteSpace: 'nowrap' }}>
                            Other Type <span style={{ color: 'red' }}>*</span>
                        </Text>
                        <Input
                            type="text"
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOtherDocumentTypeText(e.target.value)}
                            placeholder="Other Type"
                            style={{ flex: 1 }}
                        />
                    </Group>
                )}
                <Divider color="#C3C0C0" mt="md" pt="10px" />

                <Group position="right" mt="md">
                    <Button
                        variant="filled"
                        color="dark"
                        disabled={type === 'Other' && otherDocumentTypeText.trim() === ''}
                        className="delete-button"
                        onClick={() => onConfirm(otherDocumentTypeText)}
                    >
                        Yes
                    </Button>
                    <Button
                        variant="outline"
                        color="gray"
                        className="cancel-button"
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                </Group>
            </div>
        </div>
    );
};

export default UpdateTypeConfirmation;
